/* eslint-disable no-nested-ternary */
const dev = {
  NAME: "Development Mode",
  // Backend principal do frontend_hub.
  // Novas telas e fluxos do produto devem usar API_URL via services/api.
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:8091", //backend do frontend_hub
  // Backend legado/complementar usado apenas por alguns fluxos especificos.
  // So use API_HUB via services/ApiHubBackend quando o endpoint existir apenas no hub-backend.
  API_HUB: "http://localhost:8080/api", //Só utilizar com autorização
  API_PDT: "http://localhost:8091",
};

const staging = {
  NAME: "Staging Mode",
  // Backend principal do frontend_hub.
  // Novas telas e fluxos do produto devem usar API_URL via services/api.
  API_URL: "https://api-integration-flow-staging.everlog.tech", //backend do frontend_hub
  // Backend legado/complementar usado apenas por alguns fluxos especificos.
  // So use API_HUB via services/ApiHubBackend quando o endpoint existir apenas no hub-backend.
  API_HUB: "https://hub-backend-staging.everlog.tech/api", //Só utilizar com autorização
  API_PDT: "https://dashapi.everlog.tech",
  // API_PDT: "https://api-sqg-hom.everlog.tech:8443",
};

const prod = {
  NAME: "Production",
  // Backend principal do frontend_hub.
  // Novas telas e fluxos do produto devem usar API_URL via services/api.
  API_URL: "https://dashapi.everlog.tech", //backend do frontend_hub
  // Backend legado/complementar usado apenas por alguns fluxos especificos.
  // So use API_HUB via services/ApiHubBackend quando o endpoint existir apenas no hub-backend.
  API_HUB: "https://hub-production.everlog.tech/api", //Só utilizar com autorização
  API_PDT: "https://dashapi.everlog.tech",
  // API_PDT: "http://localhost:8091",
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "staging"
      ? staging
      : dev;

export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config,
};
